export const REQUEST_FIELD_DATA = 'REQUEST_FIELD_DATA';
export const FIELD_DATA_RECEIVED = 'FIELD_DATA_RECEIVED';
